import store from './config/configureStore';

const FIELD_CREATED_BY = 'CreatedBy';
const FIELD_UPDATED_BY = 'UpdatedBy';
const FIELD_DELETED_BY = 'DeletedBy';

const SOFT_DELETE_FLAGS = ['IsDeleted', 'isDeleted'];
const EXCLUDED_SERVICES = ['Citation_Court', 'CodeRepValues', 'Offenses'];

const getLoggedInUserIdentifier = () => {
  try {
    const state = store.store.getState();
    const username = state?.user?.userData?.user?.Username;
    if (username) return username;
  } catch (e) {
    console.error('userStampHook: could not resolve current user', e);
  }
  return null;
};

const isPlainObject = (v) => v !== null && typeof v === 'object' && !Array.isArray(v);

const stampOne = (record, fields) => {
  if (!isPlainObject(record)) return record;
  const next = { ...record };
  fields.forEach(({ field, value }) => {
    if (value !== null && value !== undefined) next[field] = value;
  });
  return next;
};

const applyStamp = (data, fields) => {
  if (Array.isArray(data)) return data.map((item) => stampOne(item, fields));
  return stampOne(data, fields);
};

const hasSoftDeleteFlag = (data) => {
  const check = (rec) =>
    isPlainObject(rec) && SOFT_DELETE_FLAGS.some((f) => rec[f] === true || rec[f] === 1);
  return Array.isArray(data) ? data.some(check) : check(data);
};

export const stampUser = (context) => {
  if (!['create', 'update', 'patch'].includes(context.method)) return context;
  if (EXCLUDED_SERVICES.includes(context.path)) return context;
  if (!context.data) return context;

  const user = getLoggedInUserIdentifier();
  if (!user) return context;

  const fields = [{ field: FIELD_UPDATED_BY, value: user }];

  if (context.method === 'create') {
    fields.push({ field: FIELD_CREATED_BY, value: user });
  } else if (hasSoftDeleteFlag(context.data)) {
    fields.push({ field: FIELD_DELETED_BY, value: user });
  }

  const stampedData = applyStamp(context.data, fields);
  if (isPlainObject(stampedData) && isPlainObject(stampedData.data)) {
    context.data = {
      ...stampedData,
      data: applyStamp(stampedData.data, fields),
    };
  } else {
    context.data = stampedData;
  }
  return context;
};

export const registerGlobalUserStampHook = (client) => {
  if (client.__userStampHookInstalled) return;
  client.__userStampHookInstalled = true;

  client.hooks({
    before: {
      all: [
        (context) => {
          return stampUser(context);
        },
      ],
    },
  });
};
